import * as types from "./types";

const defaultState = {
    storeList: [],
    draggableTable: {
        tableHeaders: [
            { width: '25%', label: "Name" },
            { width: '15%', label: "Redeem Code" },
            { width: '15%', label: "Sponsorship Amount" },
            { width: '15%', label: "Start Date" },
            { width: '15%', label: "End Date" },
            { width: '15%', label: "Actions" }
        ],
        tableColumns: [
            "storeName",
            "storeCode",
            "storeSponsorship",
            "storeStartDate",
            "storeEndDate"
        ]
    },
    storeForm:{
        model: "StoreModel",
        form: [
            {
                type: "text",
                label: "Store Name",
                name: "storeName",
                placeholder: "Enter store name",
                default: '',
                required: true,
                md: 12,
                xs: 12,
                maxLength: 125
            },
            {
                type: "text",
                label: "Redeem Code",
                name: "storeCode",
                required: true,
                placeholder: "Enter redeem code",
                default: '',
                md: 12,
                xs: 12,
                maxLength: 50
            },
            {
                type: "dateRange", //data will be start date and end date
                required: true,
                default: '',
                md: 12,
                xs: 12,
                maxLength: 255
            },
            {
                type: "price", 
                required: true,
                default: 0,
                label: "Sponsorship Amount",
                name: 'storeSponsorship',
                md: 5,
                xs: 12,
                min: 0,
                max: 99999999999,
                maxLength: 10
            },
            {
                component: "textarea",
                label: "Store Description",
                name: "storeDescription",
                placeholder: 'Description Here...',
                required: true,
                default: '',
                md: 12,
                xs: 12,
                maxLength: 255
            },
            {
                type: "text",
                label: "Store Username",
                name: "storeUsername",
                required: true,
                default: '',
                md: 12,
                xs: 12,
                maxLength: 50,
                placeholder: 'Enter store username',
            },
            {
                type: "text",
                label: "Store Password",
                name: "storePassword",
                required: true,
                default: '',
                md: 12,
                xs: 12,
                maxLength: 50,
                placeholder: 'Enter store password',
            },
        ]
    },
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case types.SET_LIST:
            return { ...state, storeList: action.payload };
        default: return state;
    }
};